import {application} from './application'
import TomSelectController from "./tom_select_controller"
import TempFileController from './temp_file_controller'
import RedactorController from './redactor_controller'
import CalendarController from "./calendar_controller"
import CarouselController from "./carousel_controller"
import FullCalendarController from "./full_calendar_controller"

application.register("tom-select", TomSelectController)
application.register('temp-file', TempFileController)
application.register('redactor', RedactorController)
application.register("calendar", CalendarController)
application.register("carousel", CarouselController)
application.register("full-calendar", FullCalendarController)
